const state = {
    lives : [],
    workouts : [],
    banners : [],
    kits : [],
    layoutParts : [],
    videos: [],
    activeWorkout : false,
    activeVideo : false,
    activeKit : false,
    locale : 'br',
    theme : 'smartfit'
}

export default state
